webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config__ = __webpack_require__(23);


var fluxersRef = __WEBPACK_IMPORTED_MODULE_1__firebase_config__["a" /* default */].db.ref('fluxers');

/* harmony default export */ __webpack_exports__["a"] = ({
  getCurrentUser: function getCurrentUser() {
    var keyAuth = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localStorage)[0];
    if (!keyAuth) {
      return false;
    }
    var user = JSON.parse(localStorage[keyAuth]);
    return user;
  },
  getFluxerByEmail: function getFluxerByEmail(userEmail) {
    return fluxersRef.orderByChild('email').equalTo(userEmail);
  },
  getAll: function getAll() {
    return fluxersRef.orderByChild('displayName');
  },
  getLideres: function getLideres() {
    return fluxersRef.orderByChild('lider').equalTo(true);
  },
  addUser: function addUser(user) {
    fluxersRef.child(user.providerData[0].uid).once('value', function (snapshot) {
      var exist = snapshot.val();
      if (!exist) {
        var userAdd = {};
        userAdd['displayName'] = user.providerData[0].displayName;
        userAdd['email'] = user.providerData[0].email;
        userAdd['photoURL'] = user.providerData[0].photoURL;
        fluxersRef.child(user.providerData[0].uid).set(userAdd);
      }
    });
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inbox__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Inbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MisFeedbacks__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MisFeedbacks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MisFeedbacks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReporteFeedbacks__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReporteFeedbacks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ReporteFeedbacks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReporteObjetivos__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReporteObjetivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ReporteObjetivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FeedbackDetail__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FeedbackDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_FeedbackDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FeedbackDetailAdmin__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FeedbackDetailAdmin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_FeedbackDetailAdmin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AcuerdoDeObjetivos__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AcuerdoDeObjetivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AcuerdoDeObjetivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SetObjetivos__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SetObjetivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_SetObjetivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__firebase_config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MisObjetivos__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MisObjetivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_MisObjetivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_MisMeritos__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_MisMeritos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_MisMeritos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_fluxer__ = __webpack_require__(2);




















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

function requireAuth(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_17__services_fluxer__["a" /* default */].getCurrentUser()) !== 'object') {
    console.log('User is not logged in');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    var localKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localStorage).find(function (f) {
      return f.match(/firebase:host.*/gm);
    });
    var lastDate = new Date(parseInt(JSON.parse(localStorage[localKey]).lastLoginAt));
    var truncateDate = new Date(new Date('2019-11-26').setHours(14));
    if (lastDate.getTime() < truncateDate) {
      localStorage.clear();
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      console.log('Session is okey! :)');
      next();
    }
  }
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'inbox',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Inbox___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'feedback/:id',
      name: 'feedback-detail',
      component: __WEBPACK_IMPORTED_MODULE_9__components_FeedbackDetail___default.a
    }]
  }, {
    path: '/proceso',
    name: 'mis-feedbacks',
    component: __WEBPACK_IMPORTED_MODULE_6__components_MisFeedbacks___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'mi-feedback/:id',
      name: 'mi-feedback-detail',
      component: __WEBPACK_IMPORTED_MODULE_9__components_FeedbackDetail___default.a
    }]
  }, {
    path: '/acuerdo-objetivos',
    name: 'acuerdo-objetivos',
    component: __WEBPACK_IMPORTED_MODULE_11__components_AcuerdoDeObjetivos___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'acuerdo/:id',
      name: 'set-acuerdo',
      component: __WEBPACK_IMPORTED_MODULE_12__components_SetObjetivos___default.a
    }, {
      path: 'acuerdo-detail/:id',
      name: 'acuerdo-detail',
      component: __WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail___default.a
    }]
  }, {
    path: '/mis-objetivos',
    name: 'mis-objetivos',
    component: __WEBPACK_IMPORTED_MODULE_15__components_MisObjetivos___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'mi-acuerdo-detail/:id',
      name: 'mi-acuerdo-detail',
      component: __WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail___default.a
    }]
  }, {
    path: '/reporte-feedbacks',
    name: 'reporte-feedbacks',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ReporteFeedbacks___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'feedback-admin/:id',
      name: 'feedback-detail-admin',
      component: __WEBPACK_IMPORTED_MODULE_10__components_FeedbackDetailAdmin___default.a
    }]
  }, {
    path: '/reporte-objetivos',
    name: 'reporte-objetivos',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ReporteObjetivos___default.a,
    beforeEnter: requireAuth,
    children: [{
      path: 'acuerdo-detail/:id',
      name: 'acuerdo-detail-reporte',
      component: __WEBPACK_IMPORTED_MODULE_14__components_AcuerdoDetail___default.a
    }]
  }, {
    path: '/mis-meritos',
    name: 'mis-meritos',
    component: __WEBPACK_IMPORTED_MODULE_16__components_MisMeritos___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_17__services_fluxer__["a" /* default */].getCurrentUser()) === 'object') {
        next('/');
      } else {
        next();
      }
    }
  }, {
    path: '/logout',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_13__firebase_config__["a" /* default */].auth.signOut().then(function () {
        next({ path: '/login' });
      });
    }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




var feedbacksRef = __WEBPACK_IMPORTED_MODULE_1__firebase_config__["a" /* default */].db.ref('feedbacks');
var preguntasFeedbacksRef = __WEBPACK_IMPORTED_MODULE_1__firebase_config__["a" /* default */].db.ref('preguntasFeedback');
var plantillasRef = __WEBPACK_IMPORTED_MODULE_1__firebase_config__["a" /* default */].db.ref('plantillas');

/* harmony default export */ __webpack_exports__["a"] = ({
  getById: function getById(feedbackId) {
    return feedbacksRef.child(feedbackId);
  },
  getAllFeedbacks: function getAllFeedbacks() {
    return feedbacksRef;
  },
  getPreguntasById: function getPreguntasById(feedId) {
    return preguntasFeedbacksRef.child(feedId);
  },
  getFeedbacksByEditor: function getFeedbacksByEditor(editor) {
    return feedbacksRef.orderByChild('editor').equalTo(editor);
  },
  getFeedbacksByOwner: function getFeedbacksByOwner(owner) {
    return feedbacksRef.orderByChild('owner').equalTo(owner);
  },
  create: function create(ownerUser, editorEmail, tipo, isEspontaneo) {
    var feedback = {};
    feedback['isEspontaneo'] = isEspontaneo || false;
    feedback['created'] = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database.ServerValue.TIMESTAMP;
    if (isEspontaneo) {
      feedback['owner'] = ownerUser;
    } else {
      feedback['owner'] = ownerUser.email;
    }
    feedback['editor'] = editorEmail;
    feedback['tipo'] = tipo;
    var feedId = feedbacksRef.push(feedback).key;
    plantillasRef.child(tipo).child('preguntas').once('value', function (preg) {
      preguntasFeedbacksRef.child(feedId).set(preg.val());
    });
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      resolve(feedId);
    });
  },
  guardar: function guardar(feedbackId, preguntas) {
    var preguntasDB = [];
    preguntas.forEach(function (preg) {
      var pregDB = {};
      pregDB['answer'] = preg.answer;
      pregDB['question'] = preg.question;
      if (preg.rating) {
        pregDB['rating'] = preg.rating;
      }
      preguntasDB.push(pregDB);
    });
    feedbacksRef.child(feedbackId).child('completed').set(null);
    return preguntasFeedbacksRef.child(feedbackId).set(preguntasDB);
  },
  finalizar: function finalizar(feedback, editorUser, preguntas) {
    var preguntasDB = [];
    preguntas.forEach(function (preg) {
      var pregDB = {};
      pregDB['answer'] = preg.answer;
      pregDB['question'] = preg.question;
      if (preg.rating) {
        pregDB['rating'] = preg.rating;
      }
      preguntasDB.push(pregDB);
    });
    feedbacksRef.child(feedback['.key']).child('completed').set(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database.ServerValue.TIMESTAMP);
    return preguntasFeedbacksRef.child(feedback['.key']).set(preguntasDB);
  },
  eliminar: function eliminar(feedback) {
    preguntasFeedbacksRef.child(feedback['.key']).remove();
    return feedbacksRef.child(feedback['.key']).remove();
  },
  agradecer: function agradecer(feedback) {
    return feedbacksRef.child(feedback['.key']).child('thanked').set(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database.ServerValue.TIMESTAMP);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var VueResource = __webpack_require__(385);

/* harmony default export */ __webpack_exports__["a"] = ({
  solicitarFeedback: function solicitarFeedback(feedId, editorEmail, ownerUser) {
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': editorEmail }],
      headings: { 'en': ownerUser.displayName },
      contents: { 'en': 'Te solicito feedback' },
      url: '/#/feedback/' + feedId,
      chrome_web_icon: ownerUser.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (res) {}, function (error) {
      console.log(error);
    });
  },
  enviarFeedback: function enviarFeedback(feedback, editorUser) {
    var content = void 0;
    if (feedback.isEspontaneo) {
      content = 'Te dio feedback espontaneo';
    } else {
      content = 'Finalizo el feedback que solicitaste';
    }
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': feedback.owner }],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': content },
      url: '/#/mis-feedbacks/mi-feedback/' + feedback['.key'],
      chrome_web_icon: editorUser.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (data) {}, function (error) {
      console.log(error);
    });
  },
  agradecer: function agradecer(feedback, editorUser) {
    var content = 'Te agradeció por el feedback';
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': feedback.editor }],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': content },
      url: '/#/mis-feedbacks/mi-feedback/' + feedback['.key'],
      chrome_web_icon: editorUser.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (data) {}, function (error) {
      console.log(error);
    });
  },
  enviarObjetivos: function enviarObjetivos(acuerdo, userLider) {
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': acuerdo.owner }],
      headings: { 'en': userLider.displayName },
      contents: { 'en': 'Te ha seteado nuevos objetivos' },
      url: '/#/mis-objetivos/mi-acuerdo-detail/' + acuerdo['.key'],
      chrome_web_icon: userLider.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (data) {}, function (error) {
      console.log(error);
    });
  },
  solicitarObjetivos: function solicitarObjetivos(acuerdoId, editor, ownerUser) {
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': editor }],
      headings: { 'en': ownerUser.displayName },
      contents: { 'en': 'Te ha solicitado nuevos objetivos' },
      url: '/#/acuerdo-objetivos/acuerdo/' + acuerdoId,
      chrome_web_icon: ownerUser.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (data) {}, function (error) {
      console.log(error);
    });
  },
  finalizarObjetivos: function finalizarObjetivos(acuerdoId, editorUser, owner) {
    var body = {
      app_id: "93b9f8d0-911c-4c2b-b606-0109405c988f",
      filters: [{ 'field': 'tag', 'key': 'email', 'relation': '=', 'value': owner }],
      headings: { 'en': editorUser.displayName },
      contents: { 'en': 'Ha dado por finalizado tus objetivos vigentes' },
      url: '/#/mis-objetivos/mi-acuerdo-detail/' + acuerdoId,
      chrome_web_icon: editorUser.photoURL
    };
    var headers = { 'Authorization': 'Basic ' + "ODhlNmZhNzAtNmY2NS00NTg2LTgyNjAtZGNhNTNiMmMyMmJj" };
    var options = { headers: headers };
    VueResource.Http.post('https://onesignal.com/api/v1/notifications', body, options).then(function (data) {}, function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(374),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2311f5df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var acuerdoRef = __WEBPACK_IMPORTED_MODULE_0__firebase_config__["a" /* default */].db.ref('acuerdos');
var objetivosAcuerdoRef = __WEBPACK_IMPORTED_MODULE_0__firebase_config__["a" /* default */].db.ref('objetivosAcuerdo');

var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://us-central1-feedback-e414c.cloudfunctions.net/api",
  headers: { 'Content-Type': 'application/json' }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    return acuerdoRef;
  },
  getById: function getById(acuerdoId) {
    var config = {
      url: '/acuerdo/' + acuerdoId,
      method: 'get'
    };
    return instance.request(config);
  },
  getByEmailEditor: function getByEmailEditor(editorEmail) {
    return acuerdoRef.orderByChild('editor').equalTo(editorEmail);
  },
  getByEmailOwner: function getByEmailOwner(ownerEmail) {
    return acuerdoRef.orderByChild('owner').equalTo(ownerEmail);
  },
  getObjetivosByAcuerdo: function getObjetivosByAcuerdo(acuerdoId) {
    return objetivosAcuerdoRef.child(acuerdoId);
  },
  createAcuerdo: function createAcuerdo(editor, owner) {
    var config = {
      url: '/createAcuerdo',
      method: 'post',
      data: {
        editor: editor,
        owner: owner
      }
    };
    return instance.request(config);
  },
  guardar: function guardar(acuerdoId, objetivos) {
    objetivos.forEach(function (obj) {
      delete obj['.key'];
    });
    return objetivosAcuerdoRef.child(acuerdoId).set(objetivos);
  },
  enviar: function enviar(acuerdoId, objetivos) {
    objetivos.forEach(function (obj) {
      delete obj['.key'];
    });
    var updateObject = {};
    updateObject['acuerdos/' + acuerdoId + '/sent'] = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database.ServerValue.TIMESTAMP;
    updateObject['objetivosAcuerdo/' + acuerdoId] = objetivos;
    return __WEBPACK_IMPORTED_MODULE_0__firebase_config__["a" /* default */].db.ref().update(updateObject);
  },
  finalizar: function finalizar(acuerdoId, objetivos) {
    objetivos.forEach(function (obj) {
      delete obj['.key'];
    });
    var updateObject = {};
    updateObject['acuerdos/' + acuerdoId + '/finalizado'] = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database.ServerValue.TIMESTAMP;
    updateObject['objetivosAcuerdo/' + acuerdoId] = objetivos;
    return __WEBPACK_IMPORTED_MODULE_0__firebase_config__["a" /* default */].db.ref().update(updateObject);
  }
});

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__webpack_require__.i({"apiKey":"AIzaSyByTBQMoU0gGxFCkIi7jY_FxPNrjQNQfkE","authDomain":"feedback-e414c.firebaseapp.com","databaseURL":"https://feedback-e414c.firebaseio.com","projectId":"feedback-e414c","storageBucket":"feedback-e414c.appspot.com","messagingSenderId":"532158202211"}));

/* harmony default export */ __webpack_exports__["a"] = ({
  auth: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth(),
  google: new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider(),
  db: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database()
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a30deb8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(376),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-465973ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(366),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06f6dc57",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(367),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0988bca5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(375),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__);








var moment = __webpack_require__(0);
__webpack_require__(41);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(218), {
  moment: moment
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: 'deep-purple',
  accent: 'red',
  warn: 'red',
  background: 'white'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', function (el, binding) {
  el.focus();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}).$mount('#app');

if (true) {
  var OneSignal = window.OneSignal || [];
  OneSignal.push(['init', {
    appId: "93b9f8d0-911c-4c2b-b606-0109405c988f",
    autoRegister: false,
    welcomeNotification: {
      'title': 'Feedback',
      'message': 'Gracias por suscribirse a las notificaciones!'
    }
  }]);
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      vertical: 'top',
      horizontal: 'center',
      duration: 5000,
      message: ''
    };
  },
  mounted: function mounted() {
    var snackbar = this.$refs.snackbar;
    var data = this.$data;
    this.$root.$on('showMessages', function (msg) {
      console.log(msg);
      this.$set(data, 'message', msg);
      snackbar.open();
    });
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_fluxer__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'acuerdo',
  props: ['acuerdo', 'fluxer', 'texto'],
  data: function data() {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_0__services_fluxer__["a" /* default */].getCurrentUser()
    };
  },

  firebase: function firebase() {
    return {
      showFluxer: {
        source: __WEBPACK_IMPORTED_MODULE_0__services_fluxer__["a" /* default */].getFluxerByEmail(this.fluxer)
      }
    };
  },
  methods: {}
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SetObjetivos__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SetObjetivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SetObjetivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_objetivos__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Acuerdo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'acuerdo-de-objetivos',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    'set-objetivos': __WEBPACK_IMPORTED_MODULE_1__SetObjetivos___default.a,
    'autocomplete': __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default.a,
    'acuerdo': __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default.a
  },
  data: function data() {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getCurrentUser(),
      fluxerSelected: '',
      fluxerObjectSelect: null,
      acuerdoVigente: null,
      loading: false,
      loader: true,
      error: false
    };
  },

  firebase: function firebase() {
    return {
      currentFluxer: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email),
      allFluxers: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getAll(),
      acuerdos: {
        source: __WEBPACK_IMPORTED_MODULE_3__services_objetivos__["a" /* default */].getByEmailEditor(this.currentUser.email),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      }
    };
  },
  computed: {
    acuerdosPendientes: function acuerdosPendientes() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.acuerdos, function (o) {
        return !o.sent;
      });
    },
    acuerdosEnviados: function acuerdosEnviados() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.acuerdos, function (o) {
        return o.sent;
      });
    }
  },
  methods: {
    openSelectFluxer: function openSelectFluxer(ref) {
      this.$refs[ref].open();
    },
    confirmDialog: function confirmDialog(ref) {
      var _this = this;

      var fluxerSelected = this.fluxerSelected;
      this.fluxerObjectSelect = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allFluxers, function (o) {
        return o.displayName === fluxerSelected;
      });
      if (this.fluxerObjectSelect) {
        var fluxerObjectSelect = this.fluxerObjectSelect;
        this.closeDialog(ref);
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__services_objetivos__["a" /* default */].createAcuerdo(this.currentUser.email, this.fluxerObjectSelect.email).then(function (resp) {
          if (!resp.data.hayVigente) {
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'set-acuerdo', params: { id: resp.data.acuerdoId, fluxerSelected: fluxerObjectSelect } });
          } else {
            _this.acuerdoVigente = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(_this.acuerdos, function (o) {
              return o['.key'] === resp.data.acuerdoId;
            });
            _this.$refs.advertencia.open();
          }
          _this.loading = false;
        });
      } else {
        this.error = true;
      }
    },
    verVigente: function verVigente(ref) {
      this.openDetail(this.acuerdoVigente);
      this.closeDialog(ref);
    },
    closeDialog: function closeDialog(ref) {
      this.fluxerSelected = '';
      this.$refs[ref].close();
    },
    openSetDetail: function openSetDetail(acuerdo) {
      var fluxerObjectSelect = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allFluxers, function (o) {
        return o.email === acuerdo.owner;
      });
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'set-acuerdo', params: { id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect } });
    },
    openDetail: function openDetail(acuerdo) {
      var fluxerObjectSelect = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allFluxers, function (o) {
        return o.email === acuerdo.owner;
      });
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'acuerdo-detail', params: { id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect } });
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_objetivos__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'acuerdo-detail',
  data: function data() {
    return {
      fluxerSelected: this.$route.params.fluxerSelected,
      currentUser: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getCurrentUser(),
      acuerdo: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].getById(this.$route.params.id).then(function (response) {
      _this.acuerdo = response.data;
      _this.$refs.rightSidenav.toggle();
    });
  },
  firebase: function firebase() {
    return {
      objetivos: __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].getObjetivosByAcuerdo(this.$route.params.id)
    };
  },
  methods: {
    close: function close() {
      if (this.$route.name === 'acuerdo-detail') {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'acuerdo-objetivos' });
      } else if (this.$route.name === 'acuerdo-detail-reporte') {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'reporte-objetivos' });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'mis-objetivos' });
      }
    },
    toggle: function toggle() {
      this.$refs.rightSidenav.toggle();
    },
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    change: function change(obj) {
      if (obj.cumplido) {
        obj.fecha = null;
      }
    },
    guardar: function guardar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].guardar(this.$route.params.id, this.objetivos).then(function (data) {
        _this2.closeRightSidenav();
      });
    },
    finalizar: function finalizar() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].finalizar(this.$route.params.id, this.objetivos).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2__services_notifications__["a" /* default */].finalizarObjetivos(_this3.$route.params.id, _this3.currentUser, _this3.acuerdo.owner);
        _this3.closeRightSidenav();
      });
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'autocomplete',
  props: ['value', 'label', 'array', 'debounce'],
  data: function data() {
    return {
      selected: null,
      timeout: 0,
      arrayFilter: []
    };
  },

  methods: {
    filter: function filter(param) {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        if (_this.array.length !== 0) {
          if (param) {
            _this.arrayFilter = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(_this.array, function (o) {
              return o.displayName.toLowerCase().includes(param.toLowerCase());
            });
            if (_this.arrayFilter.length !== 0) {
              _this.$refs.menu.toggle();
            }
          } else {
            _this.arrayFilter = [];
          }
          return;
        }
      }, this.debounce);
    },
    updateValue: function updateValue(value) {
      this.filter(value);
      this.$emit('input', value);
    },
    select: function select(item) {
      this.$emit('input', item.displayName);
      this.arrayFilter = [];
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_fluxer__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback',
  props: ['feedback', 'fluxer', 'texto'],
  data: function data() {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_0__services_fluxer__["a" /* default */].getCurrentUser()
    };
  },

  computed: {
    puedeVerDetalles: function puedeVerDetalles() {
      return Boolean(this.feedback) && Boolean(this.feedback.completed || this.feedback.editor === this.currentUser.email);
    },
    tituloAgradecido: function tituloAgradecido() {
      return this.$moment(this.feedback.thanked).format('DD/MM/YYYY');
    }
  },
  firebase: function firebase() {
    return {
      showFluxer: {
        source: __WEBPACK_IMPORTED_MODULE_0__services_fluxer__["a" /* default */].getFluxerByEmail(this.fluxer)
      }
    };
  },
  methods: {
    openConfirm: function openConfirm(ref) {
      this.$refs[ref].open();
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Autocomplete__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Autocomplete__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback-companion',
  props: ['currentFluxer', 'isEspontaneo'],
  components: {
    'autocomplete': __WEBPACK_IMPORTED_MODULE_5__Autocomplete___default.a
  },
  data: function data() {
    return {
      fluxerSelected: null,
      error: false
    };
  },

  firebase: function firebase() {
    return {
      allFluxers: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getAll()
    };
  },
  methods: {
    open: function open() {
      this.$refs['selectFluxer'].open();
      this.clearInput();
    },
    onOkSelectFluxer: function onOkSelectFluxer(type, ref) {
      var _this = this;

      if (type === 'ok') {
        var fluxerSelected = this.fluxerSelected;
        var fluxerSelect = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.allFluxers, function (o) {
          return o.displayName === fluxerSelected;
        });

        if (!fluxerSelect) {
          this.error = true;
        } else {
          this.error = false;
          if (!this.isEspontaneo) {
            var currentFluxer = this.currentFluxer;
            __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].create(this.currentFluxer, fluxerSelect.email, 'companion', this.isEspontaneo).then(function (feedId) {
              __WEBPACK_IMPORTED_MODULE_1__services_notifications__["a" /* default */].solicitarFeedback(feedId, fluxerSelect.email, currentFluxer);
              _this.$refs.toastFluxer.open();
              _this.$refs[ref].close();
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].create(fluxerSelect.email, this.currentFluxer.email, 'espontaneo', this.isEspontaneo).then(function (feedId) {
              __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('feedback/' + feedId);
              _this.$refs[ref].close();
            });
          }
        }
        this.$router.replace('proceso');
      } else {
        this.error = false;
        this.clearInput();
        this.$refs[ref].close();
      }
    },
    clearInput: function clearInput() {
      this.fluxerSelected = '';
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback-detail',
  data: function data() {
    return {
      feedback: ''
    };
  },

  computed: {
    currentUser: function currentUser() {
      if (!this.$route.params.currentUser) {
        return __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getCurrentUser();
      } else {
        return this.$route.params.currentUser;
      }
    },
    userOwner: function userOwner() {
      var feedback = this.feedback;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.allFluxers, function (o) {
        return o.email === feedback.owner;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.$route.params.feedback) {
      this.$bindAsObject('feedback', __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].getById(this.$route.params.id), null, function () {
        return _this.$refs.rightSidenav.toggle();
      });
    } else {
      this.feedback = this.$route.params.feedback;
      this.$refs.rightSidenav.toggle();
    }
  },
  firebase: function firebase() {
    return {
      preguntas: {
        source: __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].getPreguntasById(this.$route.params.id)
      },
      allFluxers: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getAll()
    };
  },
  methods: {
    close: function close() {
      if (this.$route.name === 'feedback-detail') {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ name: 'inbox' });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ name: 'mis-feedbacks' });
      }
    },
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    guardar: function guardar() {
      __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].guardar(this.$route.params.id, this.preguntas);
      this.$refs.rightSidenav.close();
    },
    openConfirm: function openConfirm(ref) {
      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(ref, 'end-feedback')) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.preguntas, function (p) {
          return p.answer.trim().length > 0;
        }))) {
          this.$refs['alertEmpty'].open();
          return false;
        }
      }
      this.$refs[ref].open();
    },
    finalizar: function finalizar(type) {
      var _this2 = this;

      if (type === 'ok') {
        var feedback = this.feedback;
        var editorUser = this.currentUser;
        __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].finalizar(this.feedback, this.currentUser, this.preguntas).then(function () {
          __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].enviarFeedback(feedback, editorUser);
          _this2.$refs.rightSidenav.close();
        });
        this.$router.replace('inbox');
      }
    },
    eliminar: function eliminar(type) {
      var _this3 = this;

      if (type === 'ok') {
        __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].eliminar(this.feedback).then(function () {
          _this3.$refs.rightSidenav.close();
        });
      }
    },
    thanks: function thanks() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].agradecer(this.feedback).then(function () {
        _this4.$refs.rightSidenav.close();
        __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].agradecer(_this4.feedback, _this4.currentUser);
        _this4.$root.$emit('showMessages', 'Feedback de ' + _this4.feedback.editor + ' agradecido exitosamente');
      });
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback-detail-admin',
  data: function data() {
    return {
      feedback: this.$route.params.feedback
    };
  },

  mounted: function mounted() {
    this.$refs.rightSidenav.toggle();
  },
  firebase: function firebase() {
    return {
      preguntas: __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].getPreguntasById(this.$route.params.id)
    };
  },
  methods: {
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].go(-1);
    },
    openConfirm: function openConfirm(ref) {
      this.$refs[ref].open();
    },
    editable: function editable() {
      __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].guardar(this.$route.params.id, this.preguntas);
      this.$refs.rightSidenav.close();
    },
    eliminar: function eliminar(type) {
      var _this = this;

      if (type === 'ok') {
        __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].eliminar(this.feedback).then(function () {
          _this.$refs.rightSidenav.close();
        });
      }
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_notifications__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback-lider',
  props: ['currentFluxer'],
  data: function data() {
    return {
      miLider: '',
      error: false
    };
  },

  firebase: function firebase() {
    return {
      lideres: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getLideres()
    };
  },
  methods: {
    confirmFeedLider: function confirmFeedLider() {
      this.miLider = this.currentFluxer.lider;
      this.$refs['confirmFeedLider'].open();
    },
    onConfirmFeedLider: function onConfirmFeedLider(type, ref) {
      var _this = this;

      if (type === 'ok') {
        if (!this.miLider) {
          this.error = true;
        } else {
          this.error = false;
          var miLider = this.miLider;
          var currentFluxer = this.currentFluxer;
          __WEBPACK_IMPORTED_MODULE_0__services_feedbacks__["a" /* default */].create(this.currentFluxer, this.miLider, 'lider').then(function (feedId) {
            __WEBPACK_IMPORTED_MODULE_2__services_notifications__["a" /* default */].solicitarFeedback(feedId, miLider.email, currentFluxer);
            _this.$refs.toastLider.open();
            _this.$refs[ref].close();
          });
        }
      } else {
        this.error = false;
        this.clearInput();
        this.$refs[ref].close();
      }
    },
    clearInput: function clearInput() {
      this.miLider = '';
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_fluxer__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  props: ['title', 'currentUser'],
  firebase: function firebase() {
    return {
      currentFluxer: __WEBPACK_IMPORTED_MODULE_0__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email)
    };
  },
  methods: {
    toggleLeftSidenav: function toggleLeftSidenav() {
      this.$refs.leftSidenav.toggle();
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedbackCompanion__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedbackCompanion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FeedbackCompanion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inbox',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    'feedback': __WEBPACK_IMPORTED_MODULE_1__Feedback___default.a,
    'feedback-companion': __WEBPACK_IMPORTED_MODULE_5__FeedbackCompanion___default.a
  },
  data: function data() {
    return {
      loader: true,
      currentUser: __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].getCurrentUser()
    };
  },
  created: function created() {
    window.OneSignal.push(function () {
      window.OneSignal.registerForPushNotifications();
    });
  },

  computed: {
    feedPendientes: function feedPendientes() {
      var fechaCorte = __WEBPACK_IMPORTED_MODULE_7_moment___default()('2019-11-7');
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(this.misFeedbacks, function (f) {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(f.created).isAfter(fechaCorte) && !f.completed;
      });
    },
    feedFinalizados: function feedFinalizados() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(this.misFeedbacks, function (f) {
        return f.completed;
      });
    }
  },
  firebase: function firebase() {
    this.loader = true;
    return {
      misFeedbacks: {
        source: __WEBPACK_IMPORTED_MODULE_4__services_feedbacks__["a" /* default */].getFeedbacksByEditor(this.currentUser.email),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      },
      currentFluxer: __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email)
    };
  },
  methods: {
    openDetail: function openDetail(feedback) {
      if (feedback.editor === this.currentUser.email || feedback.completed) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'feedback-detail', params: { id: feedback['.key'], feedback: feedback, currentUser: this.currentUser } });
      }
    },
    openSelectFluxer: function openSelectFluxer(ref) {
      this.$refs[ref].open();
    },
    getTitle: function getTitle(feedback) {
      if (feedback.tipo === 'lider') {
        return 'Líder';
      } else if (feedback.tipo === 'autoeval') {
        return 'Reflexión Personal';
      } else if (feedback.tipo === 'companion') {
        return 'Fluxer';
      } else {
        return 'Espontáneo';
      }
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  methods: {
    loginGoogle: function loginGoogle() {
      var providerLoginGoole = __WEBPACK_IMPORTED_MODULE_2__firebase_config__["a" /* default */].google;
      var redirect = this.$router.history.current.query.redirect || '/';
      __WEBPACK_IMPORTED_MODULE_2__firebase_config__["a" /* default */].auth.signInWithPopup(providerLoginGoole).then(function (result) {
        var user = result.user;
        var domain = user.email.substr(user.email.indexOf('@') + 1);
        if (domain !== 'fluxit.com.ar') {
          user.delete().then(function () {
            user = null;
            alert('Se debe utilizar una cuenta de FluxIT para iniciar la sesion');
          }, function (error) {
            console.log(error);
          });
        } else {
          var keyAuth = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(localStorage)[0];
          localStorage[keyAuth] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user);

          window.OneSignal.push(function () {
            window.OneSignal.sendTag('email', user.email);
          });
          __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].addUser(user);
          __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ path: redirect });
        }
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;

        var email = error.email;

        var credential = error.credential;
        console.log('Error de auth: ' + errorCode + ' ' + errorMessage + ' ' + email + ' ' + credential);
      });
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeedbackLider__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeedbackLider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FeedbackLider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeedbackCompanion__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeedbackCompanion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FeedbackCompanion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_feedbacks__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-feedbacks',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    'feedback': __WEBPACK_IMPORTED_MODULE_1__Feedback___default.a,
    'feedback-lider': __WEBPACK_IMPORTED_MODULE_2__FeedbackLider___default.a,
    'feedback-companion': __WEBPACK_IMPORTED_MODULE_3__FeedbackCompanion___default.a
  },
  data: function data() {
    return {
      loader: true,
      currentUser: __WEBPACK_IMPORTED_MODULE_5__services_fluxer__["a" /* default */].getCurrentUser(),
      fluxer: ''
    };
  },

  computed: {
    feedPendientes: function feedPendientes() {
      var fechaCorte = __WEBPACK_IMPORTED_MODULE_8_moment___default()('2019-11-7');
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.misFeedbacks, function (f) {
        return __WEBPACK_IMPORTED_MODULE_8_moment___default()(f.created).isAfter(fechaCorte) && !f.completed && !f.isEspontaneo;
      });
    },
    feedFinalizados: function feedFinalizados() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.misFeedbacks, function (o) {
        return o.completed;
      });
    }
  },
  firebase: function firebase() {
    this.loader = true;
    return {
      misFeedbacks: {
        source: __WEBPACK_IMPORTED_MODULE_6__services_feedbacks__["a" /* default */].getFeedbacksByOwner(this.currentUser.email),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      },
      currentFluxer: __WEBPACK_IMPORTED_MODULE_5__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email)
    };
  },
  methods: {
    openFeedLider: function openFeedLider(ref) {
      this.$refs[ref].confirmFeedLider();
    },
    openSelectFluxer: function openSelectFluxer(ref) {
      this.$refs[ref].open();
    },
    confirmAutoeval: function confirmAutoeval(ref) {
      this.$refs[ref].open();
    },
    onConfirmAutoeval: function onConfirmAutoeval(type) {
      var _this = this;

      if (type === 'ok') {
        __WEBPACK_IMPORTED_MODULE_6__services_feedbacks__["a" /* default */].create(this.currentUser, this.currentUser.email, 'autoeval').then(function (feedId) {
          _this.$refs.toastAutoeval.open();
        });
      }
    },
    openDetail: function openDetail(feedback) {
      if (!feedback.completed && feedback.editor !== this.currentUser.email) {
        return false;
      }
      if (feedback.editor === this.currentUser.email || feedback.completed) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'mi-feedback-detail', params: { id: feedback['.key'], feedback: feedback, currentUser: this.currentUser } });
      } else {
        this.$refs['advertencia'].open();
      }
    },
    getTitle: function getTitle(feedback) {
      if (feedback.tipo === 'lider') {
        return 'Líder';
      } else if (feedback.tipo === 'autoeval') {
        return 'Reflexión Personal';
      } else if (feedback.tipo === 'companion') {
        return 'Fluxer';
      } else {
        return 'Espontáneo';
      }
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_objetivos__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Acuerdo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-objetivos',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    'autocomplete': __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default.a,
    'acuerdo': __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default.a
  },
  data: function data() {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getCurrentUser(),
      liderSelected: '',
      loading: false,
      loader: true,
      error: false
    };
  },

  computed: {
    acuerdoVigente: function acuerdoVigente() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.misAcuerdos, function (o) {
        return !o.finalizado;
      });
    },
    acuerdosArchivados: function acuerdosArchivados() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.misAcuerdos, function (o) {
        return o.finalizado;
      });
    }
  },
  firebase: function firebase() {
    return {
      allLideres: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getLideres(),
      misAcuerdos: {
        source: __WEBPACK_IMPORTED_MODULE_2__services_objetivos__["a" /* default */].getByEmailOwner(this.currentUser.email),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      }
    };
  },
  methods: {
    openSelectFluxer: function openSelectFluxer(ref) {
      this.$refs[ref].open();
    },
    confirmDialog: function confirmDialog(ref) {
      var _this = this;

      var liderSelected = this.liderSelected;
      var liderObjectSelect = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allLideres, function (o) {
        return o.displayName === liderSelected;
      });
      if (liderObjectSelect) {
        var currentUser = this.currentUser;
        this.closeDialog(ref);
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_objetivos__["a" /* default */].createAcuerdo(liderObjectSelect.email, this.currentUser.email).then(function (resp) {
          if (!resp.data.hayVigente) {
            __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].solicitarObjetivos(resp.data.acuerdoId, liderObjectSelect.email, currentUser);
          } else {
            _this.$refs.advertencia.open();
          }
          _this.loading = false;
        });
      } else {
        this.error = true;
      }
    },
    closeDialog: function closeDialog(ref) {
      this.liderSelected = '';
      this.error = false;
      this.$refs[ref].close();
    },
    verVigente: function verVigente(ref) {
      this.openDetail();
      this.closeDialog(ref);
    },
    openDetail: function openDetail(acuerdo) {
      if (!acuerdo) {
        acuerdo = this.acuerdoVigente;
      }
      if (acuerdo.sent) {
        var lider = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allLideres, function (o) {
          return o.email === acuerdo.editor;
        });
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'mi-acuerdo-detail', params: { id: acuerdo['.key'], fluxerSelected: lider } });
      } else {
        this.$refs.advertenciaAcuerdo.open();
      }
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_objetivos__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Acuerdo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-objetivos',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    'autocomplete': __WEBPACK_IMPORTED_MODULE_4__Autocomplete___default.a,
    'acuerdo': __WEBPACK_IMPORTED_MODULE_5__Acuerdo___default.a
  },
  data: function data() {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getCurrentUser(),
      liderSelected: '',
      loading: false,
      loader: true,
      error: false
    };
  },

  computed: {
    acuerdoVigente: function acuerdoVigente() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.misAcuerdos, function (o) {
        return !o.finalizado;
      });
    },
    acuerdosArchivados: function acuerdosArchivados() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.misAcuerdos, function (o) {
        return o.finalizado;
      });
    }
  },
  firebase: function firebase() {
    return {
      allLideres: __WEBPACK_IMPORTED_MODULE_1__services_fluxer__["a" /* default */].getLideres(),
      misAcuerdos: {
        source: __WEBPACK_IMPORTED_MODULE_2__services_objetivos__["a" /* default */].getByEmailOwner(this.currentUser.email),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      }
    };
  },
  methods: {
    openSelectFluxer: function openSelectFluxer(ref) {
      this.$refs[ref].open();
    },
    confirmDialog: function confirmDialog(ref) {
      var _this = this;

      var liderSelected = this.liderSelected;
      var liderObjectSelect = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allLideres, function (o) {
        return o.displayName === liderSelected;
      });
      if (liderObjectSelect) {
        var currentUser = this.currentUser;
        this.closeDialog(ref);
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_objetivos__["a" /* default */].createAcuerdo(liderObjectSelect.email, this.currentUser.email).then(function (resp) {
          if (!resp.data.hayVigente) {
            __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].solicitarObjetivos(resp.data.acuerdoId, liderObjectSelect.email, currentUser);
          } else {
            _this.$refs.advertencia.open();
          }
          _this.loading = false;
        });
      } else {
        this.error = true;
      }
    },
    closeDialog: function closeDialog(ref) {
      this.liderSelected = '';
      this.error = false;
      this.$refs[ref].close();
    },
    verVigente: function verVigente(ref) {
      this.openDetail();
      this.closeDialog(ref);
    },
    openDetail: function openDetail(acuerdo) {
      if (!acuerdo) {
        acuerdo = this.acuerdoVigente;
      }
      if (acuerdo.sent) {
        var lider = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.allLideres, function (o) {
          return o.email === acuerdo.editor;
        });
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'mi-acuerdo-detail', params: { id: acuerdo['.key'], fluxerSelected: lider } });
      } else {
        this.$refs.advertenciaAcuerdo.open();
      }
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_feedbacks__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte-feedbacks',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a
  },
  data: function data() {
    return {
      loader: false,
      currentUser: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getCurrentUser()
    };
  },

  firebase: function firebase() {
    this.loader = true;
    return {
      allFeedbacks: {
        source: __WEBPACK_IMPORTED_MODULE_3__services_feedbacks__["a" /* default */].getAllFeedbacks(),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      },
      currentFluxer: __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email)
    };
  },
  methods: {
    openDetail: function openDetail(feed) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'feedback-detail-admin', params: { id: feed['.key'], feedback: feed } });
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_objetivos__ = __webpack_require__(21);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte-objetivos',
  components: {
    'headerFeed': __WEBPACK_IMPORTED_MODULE_0__Header___default.a
  },
  data: function data() {
    return {
      loader: false,
      currentUser: __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].getCurrentUser()
    };
  },

  firebase: function firebase() {
    this.loader = true;
    return {
      allAcuerdos: {
        source: __WEBPACK_IMPORTED_MODULE_4__services_objetivos__["a" /* default */].getAll(),
        readyCallback: function readyCallback() {
          this.loader = false;
        }
      },
      allFluxers: __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].getAll(),
      currentFluxer: __WEBPACK_IMPORTED_MODULE_3__services_fluxer__["a" /* default */].getFluxerByEmail(this.currentUser.email)
    };
  },
  methods: {
    openDetail: function openDetail(acuerdo) {
      var fluxerObjectSelect = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.allFluxers, function (o) {
        return o.email === acuerdo.owner;
      });
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'acuerdo-detail-reporte', params: { id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect } });
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_objetivos__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_fluxer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'set-objetivos',
  data: function data() {
    return {
      fluxerSelected: this.$route.params.fluxerSelected,
      acuerdo: false
    };
  },

  firebase: function firebase() {
    return {
      objetivos: __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].getObjetivosByAcuerdo(this.$route.params.id)
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].getById(this.$route.params.id).then(function (response) {
      _this.acuerdo = response.data;
    });
  },
  beforeUpdate: function beforeUpdate() {
    if (this.$refs.rightSidenav) {
      this.$refs.rightSidenav.open();
    }
  },
  methods: {
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ name: 'acuerdo-objetivos' });
    },
    toggle: function toggle() {
      this.$refs.rightSidenav.toggle();
    },
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    addObjetivo: function addObjetivo() {
      var obj = {
        descripcion: '',
        notas: '',
        cumplido: false
      };
      this.objetivos.push(obj);
    },
    deleteObj: function deleteObj(index) {
      this.objetivos.splice(index, 1);
    },
    guardar: function guardar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].guardar(this.$route.params.id, this.objetivos).then(function () {
        _this2.closeRightSidenav();
      });
    },
    enviar: function enviar() {
      var _this3 = this;

      var acuerdo = this.acuerdo;
      __WEBPACK_IMPORTED_MODULE_0__services_objetivos__["a" /* default */].enviar(this.$route.params.id, this.objetivos).then(function () {
        __WEBPACK_IMPORTED_MODULE_1__services_notifications__["a" /* default */].enviarObjetivos(acuerdo, __WEBPACK_IMPORTED_MODULE_2__services_fluxer__["a" /* default */].getCurrentUser());
        _this3.$refs.snackbar.open();
        _this3.closeRightSidenav();
      });
    }
  }
});

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 96,
	"./af.js": 96,
	"./ar": 103,
	"./ar-dz": 97,
	"./ar-dz.js": 97,
	"./ar-kw": 98,
	"./ar-kw.js": 98,
	"./ar-ly": 99,
	"./ar-ly.js": 99,
	"./ar-ma": 100,
	"./ar-ma.js": 100,
	"./ar-sa": 101,
	"./ar-sa.js": 101,
	"./ar-tn": 102,
	"./ar-tn.js": 102,
	"./ar.js": 103,
	"./az": 104,
	"./az.js": 104,
	"./be": 105,
	"./be.js": 105,
	"./bg": 106,
	"./bg.js": 106,
	"./bn": 107,
	"./bn.js": 107,
	"./bo": 108,
	"./bo.js": 108,
	"./br": 109,
	"./br.js": 109,
	"./bs": 110,
	"./bs.js": 110,
	"./ca": 111,
	"./ca.js": 111,
	"./cs": 112,
	"./cs.js": 112,
	"./cv": 113,
	"./cv.js": 113,
	"./cy": 114,
	"./cy.js": 114,
	"./da": 115,
	"./da.js": 115,
	"./de": 118,
	"./de-at": 116,
	"./de-at.js": 116,
	"./de-ch": 117,
	"./de-ch.js": 117,
	"./de.js": 118,
	"./dv": 119,
	"./dv.js": 119,
	"./el": 120,
	"./el.js": 120,
	"./en-au": 121,
	"./en-au.js": 121,
	"./en-ca": 122,
	"./en-ca.js": 122,
	"./en-gb": 123,
	"./en-gb.js": 123,
	"./en-ie": 124,
	"./en-ie.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./eo": 126,
	"./eo.js": 126,
	"./es": 41,
	"./es-do": 127,
	"./es-do.js": 127,
	"./es.js": 41,
	"./et": 128,
	"./et.js": 128,
	"./eu": 129,
	"./eu.js": 129,
	"./fa": 130,
	"./fa.js": 130,
	"./fi": 131,
	"./fi.js": 131,
	"./fo": 132,
	"./fo.js": 132,
	"./fr": 135,
	"./fr-ca": 133,
	"./fr-ca.js": 133,
	"./fr-ch": 134,
	"./fr-ch.js": 134,
	"./fr.js": 135,
	"./fy": 136,
	"./fy.js": 136,
	"./gd": 137,
	"./gd.js": 137,
	"./gl": 138,
	"./gl.js": 138,
	"./gom-latn": 139,
	"./gom-latn.js": 139,
	"./he": 140,
	"./he.js": 140,
	"./hi": 141,
	"./hi.js": 141,
	"./hr": 142,
	"./hr.js": 142,
	"./hu": 143,
	"./hu.js": 143,
	"./hy-am": 144,
	"./hy-am.js": 144,
	"./id": 145,
	"./id.js": 145,
	"./is": 146,
	"./is.js": 146,
	"./it": 147,
	"./it.js": 147,
	"./ja": 148,
	"./ja.js": 148,
	"./jv": 149,
	"./jv.js": 149,
	"./ka": 150,
	"./ka.js": 150,
	"./kk": 151,
	"./kk.js": 151,
	"./km": 152,
	"./km.js": 152,
	"./kn": 153,
	"./kn.js": 153,
	"./ko": 154,
	"./ko.js": 154,
	"./ky": 155,
	"./ky.js": 155,
	"./lb": 156,
	"./lb.js": 156,
	"./lo": 157,
	"./lo.js": 157,
	"./lt": 158,
	"./lt.js": 158,
	"./lv": 159,
	"./lv.js": 159,
	"./me": 160,
	"./me.js": 160,
	"./mi": 161,
	"./mi.js": 161,
	"./mk": 162,
	"./mk.js": 162,
	"./ml": 163,
	"./ml.js": 163,
	"./mr": 164,
	"./mr.js": 164,
	"./ms": 166,
	"./ms-my": 165,
	"./ms-my.js": 165,
	"./ms.js": 166,
	"./my": 167,
	"./my.js": 167,
	"./nb": 168,
	"./nb.js": 168,
	"./ne": 169,
	"./ne.js": 169,
	"./nl": 171,
	"./nl-be": 170,
	"./nl-be.js": 170,
	"./nl.js": 171,
	"./nn": 172,
	"./nn.js": 172,
	"./pa-in": 173,
	"./pa-in.js": 173,
	"./pl": 174,
	"./pl.js": 174,
	"./pt": 176,
	"./pt-br": 175,
	"./pt-br.js": 175,
	"./pt.js": 176,
	"./ro": 177,
	"./ro.js": 177,
	"./ru": 178,
	"./ru.js": 178,
	"./sd": 179,
	"./sd.js": 179,
	"./se": 180,
	"./se.js": 180,
	"./si": 181,
	"./si.js": 181,
	"./sk": 182,
	"./sk.js": 182,
	"./sl": 183,
	"./sl.js": 183,
	"./sq": 184,
	"./sq.js": 184,
	"./sr": 186,
	"./sr-cyrl": 185,
	"./sr-cyrl.js": 185,
	"./sr.js": 186,
	"./ss": 187,
	"./ss.js": 187,
	"./sv": 188,
	"./sv.js": 188,
	"./sw": 189,
	"./sw.js": 189,
	"./ta": 190,
	"./ta.js": 190,
	"./te": 191,
	"./te.js": 191,
	"./tet": 192,
	"./tet.js": 192,
	"./th": 193,
	"./th.js": 193,
	"./tl-ph": 194,
	"./tl-ph.js": 194,
	"./tlh": 195,
	"./tlh.js": 195,
	"./tr": 196,
	"./tr.js": 196,
	"./tzl": 197,
	"./tzl.js": 197,
	"./tzm": 199,
	"./tzm-latn": 198,
	"./tzm-latn.js": 198,
	"./tzm.js": 199,
	"./uk": 200,
	"./uk.js": 200,
	"./ur": 201,
	"./ur.js": 201,
	"./uz": 203,
	"./uz-latn": 202,
	"./uz-latn.js": 202,
	"./uz.js": 203,
	"./vi": 204,
	"./vi.js": 204,
	"./x-pseudo": 205,
	"./x-pseudo.js": 205,
	"./yo": 206,
	"./yo.js": 206,
	"./zh-cn": 207,
	"./zh-cn.js": 207,
	"./zh-hk": 208,
	"./zh-hk.js": 208,
	"./zh-tw": 209,
	"./zh-tw.js": 209
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348;

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google-icon.1c6e97b.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-login.6734a63.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.828c6b0.png";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21c095f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(380),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e11378d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(368),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(383),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d983a86e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(384),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(378),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(377),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', [(_vm.showFluxer[0]) ? _c('md-card', {
    attrs: {
      "md-with-hover": _vm.puedeVerDetalles
    }
  }, [_c('md-card-header', [_c('md-card-media', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.showFluxer[0].photoURL,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("\n                      " + _vm._s(_vm.showFluxer[0].displayName) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('div', [(!_vm.feedback.isEspontaneo) ? _c('p', [_vm._v(_vm._s(_vm.texto))]) : _vm._e(), _vm._v(" "), (_vm.feedback.isEspontaneo) ? _c('p', [_vm._v("Feedback espontaneo")]) : _vm._e()])])])], 1), _vm._v(" "), _c('md-card-header', {
    staticClass: "footer"
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": true
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', [(_vm.feedback.thanked) ? _c('span', {
    attrs: {
      "title": _vm.tituloAgradecido
    }
  }, [_c('md-icon', [_vm._v("thumb_up")])], 1) : _vm._e()]), _vm._v(" "), (_vm.feedback.completed) ? _c('md-layout', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.feedback.completed, "DD/MM/YYYY")))])]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "selectFluxer",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [(!_vm.isEspontaneo) ? _c('md-dialog-title', [_vm._v("Pedir feedback a un compañero")]) : _vm._e(), _vm._v(" "), (_vm.isEspontaneo) ? _c('md-dialog-title', [_vm._v("Dar feedback espontaneo")]) : _vm._e(), _vm._v(" "), _c('md-dialog-content', [_c('autocomplete', {
    attrs: {
      "label": 'Busca al fluxer aqui',
      "array": _vm.allFluxers,
      "debounce": 1000
    },
    model: {
      value: (_vm.fluxerSelected),
      callback: function($$v) {
        _vm.fluxerSelected = $$v
      },
      expression: "fluxerSelected"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("El fluxer seleccionado es incorrecto")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onOkSelectFluxer('cancel', 'selectFluxer')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onOkSelectFluxer('ok', 'selectFluxer')
      }
    }
  }, [_vm._v("aceptar")])], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "toastFluxer",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 4000
    },
    on: {
      "close": function($event) {
        _vm.clearInput()
      }
    }
  }, [(!_vm.isEspontaneo) ? _c('span', [_vm._v("El feedback se pidio correctamente a: " + _vm._s(_vm.fluxerSelected) + " ")]) : _vm._e(), _vm._v(" "), (_vm.isEspontaneo) ? _c('span', [_vm._v("El feedback espontaneo a: " + _vm._s(_vm.fluxerSelected) + " se creo correctamente ")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('main', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(352)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.loginGoogle($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": __webpack_require__(351)
    }
  }), _vm._v("\n      Login Gmail Flux\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentFluxer[0]) ? _c('div', {
    staticClass: "reporte-feedbacks"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Reportes de Feedbacks"
    }
  }), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("Estado")]), _vm._v(" "), _c('md-table-head', [_vm._v("Tipo")]), _vm._v(" "), _c('md-table-head', [_vm._v("Dueño")]), _vm._v(" "), _c('md-table-head', [_vm._v("Editor")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de solicitud")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de completado")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.allFeedbacks), function(feed, index) {
    return _c('md-table-row', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }, [(feed.completed) ? _c('md-table-cell', [_vm._v("Finalizado")]) : _c('md-table-cell', [_vm._v("Pendiente")]), _vm._v(" "), (!feed.isEspontaneo) ? _c('md-table-cell', [_vm._v(_vm._s(feed.tipo))]) : _vm._e(), _vm._v(" "), (feed.isEspontaneo) ? _c('md-table-cell', [_vm._v("Espontaneo")]) : _vm._e(), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(feed.owner))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(feed.editor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(feed.created, "YYYY/MM/DD - HH:mm")))]), _vm._v(" "), (feed.completed) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(feed.completed, "YYYY/MM/DD - HH:mm")))]) : _c('md-table-cell', [_vm._v("-")])], 1)
  }))], 1) : _vm._e()], 1) : _c('div', [_vm._v("\n      Necesita ser Administrador de la app para ver esta seccion\n  ")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser !== null && _vm.currentFluxer[0]) ? _c('div', {
    staticClass: "Objetivos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Acuerdo de Objetivos"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "contenidoPagina",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("En borrador")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.acuerdosPendientes.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes un acuerdos de objetivos en borrador aún.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.acuerdosPendientes), function(acuerdo) {
    return _c('div', [_c('acuerdo', {
      key: acuerdo['.key'],
      attrs: {
        "acuerdo": acuerdo,
        "fluxer": acuerdo.owner
      },
      nativeOn: {
        "click": function($event) {
          _vm.openSetDetail(acuerdo)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Enviados")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.acuerdosEnviados.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes un acuerdos de objetivos archivados aún.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.acuerdosEnviados), function(acuerdo) {
    return _c('div', [_c('acuerdo', {
      key: acuerdo['.key'],
      attrs: {
        "acuerdo": acuerdo,
        "fluxer": acuerdo.owner
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(acuerdo)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog-objetivos",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("Seleccione fluxer")]), _vm._v(" "), _c('md-dialog-content', [_c('autocomplete', {
    attrs: {
      "label": 'Busca al fluxer aqui',
      "array": _vm.allFluxers,
      "debounce": 1000
    },
    model: {
      value: (_vm.fluxerSelected),
      callback: function($$v) {
        _vm.fluxerSelected = $$v
      },
      expression: "fluxerSelected"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("El fluxer seleccionado es incorrecto")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('dialog-objetivos')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.confirmDialog('dialog-objetivos')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "advertencia",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_vm._v("El fluxer ya tiene un acuerdo de objetivos vigente, debe finalizarlo para poder crear otro")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.verVigente('advertencia')
      }
    }
  }, [_vm._v("Ver acuerdo vigente")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('advertencia')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fluxerSelected) ? _c('div', [_c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Acuerdo de Objetivos")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _vm._v(" "), _c('md-subheader', [(_vm.acuerdo) ? _c('div', [_vm._v("Dueño " + _vm._s(_vm.acuerdo.ownerObject.displayName))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_vm._l((_vm.objetivos), function(obj, index) {
    return _c('md-card', {
      key: index,
      staticClass: "card-obj",
      attrs: {
        "md-flex-xsmall": "100",
        "md-flex-small": "50",
        "md-flex-medium": "50",
        "md-align": "center"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Objetivo " + _vm._s(index + 1))]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button delete-obj",
      nativeOn: {
        "click": function($event) {
          _vm.deleteObj(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-input-container', [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "debounce": "5000",
        "required": "true"
      },
      model: {
        value: (obj.descripcion),
        callback: function($$v) {
          obj.descripcion = $$v
        },
        expression: "obj.descripcion"
      }
    })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Notas")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "debounce": "5000",
        "required": "true"
      },
      model: {
        value: (obj.notas),
        callback: function($$v) {
          obj.notas = $$v
        },
        expression: "obj.notas"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-card', {
    staticClass: "card-obj",
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Nuevo Objetivo")])]), _vm._v(" "), _c('md-card-content', [_c('md-button', {
    staticClass: "md-icon-button md-raised md-dense",
    nativeOn: {
      "click": function($event) {
        _vm.addObjetivo()
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 2), _vm._v(" "), (!_vm.acuerdo.sent) ? _c('div', {
    staticClass: "container-buttons"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Guardar borrador")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.enviar()
      }
    }
  }, [_vm._v("Enviar")])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 3000
    }
  }, [_c('span', [_vm._v("El acuerdo de objetivos se envio correctamente a " + _vm._s(_vm.fluxerSelected.displayName))])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser !== null) ? _c('div', {
    staticClass: "inbox"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Feedback a Fluxers"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "contenidoPagina",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Pendientes ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedPendientes.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes Feedbacks pendientes aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedPendientes), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.owner,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Enviados ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedFinalizados.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes Feedbacks finalizados aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedFinalizados), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.owner,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser == null) ? _c('div', [_vm._v("\n    el currentUser es null!!\n  ")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button espontaneo md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.openSelectFluxer('selectFluxer')
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Dar feedback espontaneo")])], 1), _vm._v(" "), _c('feedback-companion', {
    ref: "selectFluxer",
    attrs: {
      "isEspontaneo": true,
      "currentFluxer": _vm.currentFluxer[0]
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right feedback-detail",
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [(_vm.userOwner) ? _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Feedback a " + _vm._s(_vm.userOwner.displayName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [(_vm.feedback.tipo === 'autoeval') ? _c('md-icon', {
    staticClass: "icon-feed"
  }, [_vm._v("person")]) : _vm._e(), _vm._v(" "), (_vm.feedback.tipo === 'companion') ? _c('md-icon', {
    staticClass: "icon-feed"
  }, [_vm._v("swap_horiz")]) : _vm._e(), _vm._v(" "), (_vm.feedback.tipo === 'lider') ? _c('md-icon', {
    staticClass: "icon-feed"
  }, [_vm._v("arrow_downward")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close-feedback",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _vm._v(" "), (_vm.feedback) ? _c('md-list', {
    staticClass: "form-question"
  }, _vm._l((_vm.preguntas), function(preg) {
    return _c('md-list-item', {
      key: preg.key
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('p', {
      staticClass: "md-center question"
    }, [_vm._v(_vm._s(preg.question))]), _vm._v(" "), _c('md-input-container', {
      attrs: {
        "md-inline": ""
      }
    }, [(!_vm.feedback.completed) ? _c('label') : _vm._e(), _vm._v(" "), _c('md-textarea', {
      staticClass: "answer",
      attrs: {
        "readonly": _vm.feedback.completed !== undefined
      },
      model: {
        value: (preg.answer),
        callback: function($$v) {
          preg.answer = $$v
        },
        expression: "preg.answer"
      }
    })], 1)], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.feedback.completed) ? _c('div', {
    staticClass: "container-buttons"
  }, [(!_vm.feedback.thanked && _vm.currentUser.email !== _vm.feedback.editor) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.thanks()
      }
    }
  }, [_c('md-icon', [_vm._v("thumb_up")]), _vm._v(" Gracias!\n      ")], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav($event)
      }
    }
  }, [_vm._v("Ok")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-buttons"
  }, [(_vm.feedback.owner === _vm.currentUser.email && !_vm.feedback.completed) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.openConfirm('delete-feedback')
      }
    }
  }, [_vm._v("Eliminar")]) : _vm._e(), _vm._v(" "), (_vm.feedback.editor === _vm.currentUser.email && !_vm.feedback.completed) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Guardar borrador")]) : _vm._e(), _vm._v(" "), (_vm.feedback.editor === _vm.currentUser.email && !_vm.feedback.completed) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.openConfirm('end-feedback')
      }
    }
  }, [_vm._v("Enviar")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "end-feedback",
    attrs: {
      "md-title": '',
      "md-content-html": 'Enviar el Feedback?',
      "md-ok-text": 'Enviar',
      "md-cancel-text": 'Seguir editando'
    },
    on: {
      "close": _vm.finalizar
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "delete-feedback",
    attrs: {
      "md-title": '',
      "md-content-html": 'Se va a eliminar el Feedback, esta operacion no puede ser revertida, desea continuar?',
      "md-ok-text": 'Eliminar',
      "md-cancel-text": 'Seguir editando'
    },
    on: {
      "close": _vm.eliminar,
      "": function($event) {}
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertEmpty",
    attrs: {
      "md-content": 'Completar al menos un item antes de enviar el Feedback',
      "md-ok-text": 'Aceptar'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('md-toolbar', {
    staticClass: "md-whiteframe main-header  md-whiteframe-1dp"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.toggleLeftSidenav($event)
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-hide-small": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(353)
    }
  })])], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    attrs: {
      "md-swipeable": true
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-avatar', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentUser.photoURL,
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "md-title nickname"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.displayName) + " ")])], 1)]), _vm._v(" "), (_vm.currentFluxer[0]) ? _c('md-list', [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "proceso"
    }
  }, [_c('md-icon', [_vm._v("question_answer")]), _vm._v(" "), _c('span', [_vm._v("Proceso de Feedback")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('md-icon', [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('span', [_vm._v("Feedback a Fluxers")])], 1)], 1), _vm._v(" "), (_vm.currentFluxer[0].lider) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/acuerdo-objetivos"
    }
  }, [_c('md-icon', [_vm._v("playlist_add_check")]), _vm._v(" "), _c('span', [_vm._v("Acuerdo De Objetivos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/mis-objetivos"
    }
  }, [_c('md-icon', [_vm._v("playlist_add_check")]), _vm._v(" "), _c('span', [_vm._v("Mis Objetivos")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/mis-meritos"
    }
  }, [_c('md-icon'), _vm._v(" "), _c('span', [_vm._v("Mis Meritos")])], 1)], 1), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/admin-mis-meritos"
    }
  }, [_c('md-icon'), _vm._v(" "), _c('span', [_vm._v("Administrar Mis Meritos")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/reporte-feedbacks"
    }
  }, [_c('md-icon', [_vm._v("assessment")]), _vm._v(" "), _c('span', [_vm._v("Reporte de Feedbacks")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/reporte-objetivos"
    }
  }, [_c('md-icon', [_vm._v("assessment")]), _vm._v(" "), _c('span', [_vm._v("Reporte de Objetivos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")]), _vm._v(" "), _c('span', [_vm._v("Salir")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acuerdo"
  }, [_c('main', [(_vm.showFluxer[0]) ? _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('md-card-media', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.showFluxer[0].photoURL,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('md-card-header-text', [_c('div', {
    staticClass: "md-title name"
  }, [_vm._v("\n                      " + _vm._s(_vm.showFluxer[0].displayName) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('div', [(_vm.acuerdo.finalizado) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.acuerdo.sent && !_vm.acuerdo.finalizado) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("En Proceso")]) : _vm._e(), _vm._v(" "), (!_vm.acuerdo.sent) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("En Edicion")]) : _vm._e()])])])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentFluxer[0]) ? _c('div', {
    staticClass: "reporte-objetivos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Reportes de Objetivos"
    }
  }), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("Dueño")]), _vm._v(" "), _c('md-table-head', [_vm._v("Lider")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de creacion")]), _vm._v(" "), _c('md-table-head', [_vm._v("Acuerdo vigente")]), _vm._v(" "), _c('md-table-head', [_vm._v("Acuerdo finalizado")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.allAcuerdos), function(acuerdo, index) {
    return _c('md-table-row', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(acuerdo)
        }
      }
    }, [_c('md-table-cell', [_vm._v(_vm._s(acuerdo.owner))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(acuerdo.editor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.created, "YYYY/MM/DD HH:mm")))]), _vm._v(" "), (acuerdo.sent) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.sent, "YYYY/MM/DD HH:mm")))]) : _c('md-table-cell', [_vm._v("-")]), _vm._v(" "), (acuerdo.finalizado) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.finalizado, "YYYY/MM/DD HH:mm")))]) : _c('md-table-cell', [_vm._v("-")])], 1)
  }))], 1) : _vm._e()], 1) : _c('div', [_vm._v("\n      Necesita ser Administrador de la app para ver esta seccion\n  ")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser) ? _c('div', {
    staticClass: "Objetivos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Mis Objetivos"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "contenidoPagina",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Vigente")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (!_vm.acuerdoVigente && !_vm.loader) ? _c('p', [_vm._v("No tienes un acuerdo de objetivos aún. Pedile a tu lider que te genere uno.")]) : _vm._e(), _vm._v(" "), (_vm.acuerdoVigente) ? _c('acuerdo', {
    key: _vm.acuerdoVigente['.key'],
    attrs: {
      "showEditor": true,
      "acuerdo": _vm.acuerdoVigente,
      "fluxer": _vm.acuerdoVigente.editor
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDetail()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Archivados")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.acuerdosArchivados.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tenés acuerdos de objetivos archivados aún.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.acuerdosArchivados), function(acuerdo) {
    return _c('div', [(acuerdo.sent) ? _c('acuerdo', {
      key: acuerdo['.key'],
      attrs: {
        "showEditor": true,
        "acuerdo": acuerdo,
        "fluxer": acuerdo.editor
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(acuerdo)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('br')], 1)
  })], 2)])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog-objetivos",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("Seleccione a su lider")]), _vm._v(" "), _c('md-dialog-content', [_c('autocomplete', {
    attrs: {
      "label": 'Busca al lider aqui',
      "array": _vm.allLideres,
      "debounce": 1000
    },
    model: {
      value: (_vm.liderSelected),
      callback: function($$v) {
        _vm.liderSelected = $$v
      },
      expression: "liderSelected"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("El fluxer seleccionado es incorrecto, selecciona otro.")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('dialog-objetivos')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.confirmDialog('dialog-objetivos')
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "advertencia",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_vm._v("Ya tenes un acuerdo de objetivos previo, debe finalizarse el vigente para crear uno nuevo")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.verVigente('advertencia')
      }
    }
  }, [_vm._v("Ver acuerdo vigente")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('advertencia')
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "advertenciaAcuerdo",
    attrs: {
      "md-title": '',
      "md-content": 'Hasta que tu lider no te envíe el acuerdo de objetivos no podras acceder al detalle.',
      "md-ok-text": 'Aceptar'
    }
  }), _vm._v(" "), _c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acuerdo-detail"
  }, [_c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h4', {
    staticClass: "md-title"
  }, [_vm._v("Acuerdo de Objetivos")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _vm._v(" "), _c('md-subheader', [(_vm.acuerdo) ? _c('div', [_vm._v("Dueño " + _vm._s(_vm.acuerdo.ownerObject.displayName))]) : _vm._e()]), _vm._v(" "), _c('md-subheader', [(_vm.acuerdo) ? _c('div', [_vm._v("Editor " + _vm._s(_vm.acuerdo.editorObject.displayName))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.objetivos), function(obj, index) {
    return _c('md-card', {
      key: index,
      staticClass: "card-obj-detail",
      attrs: {
        "md-flex-xsmall": "100",
        "md-flex-small": "50",
        "md-flex-medium": "50",
        "md-align": "center"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Objetivo " + _vm._s(index + 1))])]), _vm._v(" "), _c('md-card-content', [_c('div', [_vm._v("\n                      " + _vm._s(obj.descripcion) + "\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      " + _vm._s(obj.notas) + "\n                  ")]), _vm._v(" "), _c('md-checkbox', {
      attrs: {
        "disabled": _vm.acuerdo && (_vm.currentUser.email !== _vm.acuerdo.editorObject.email || _vm.acuerdo.finalizado !== undefined)
      },
      on: {
        "change": function($event) {
          _vm.change(obj)
        }
      },
      model: {
        value: (obj.cumplido),
        callback: function($$v) {
          obj.cumplido = $$v
        },
        expression: "obj.cumplido"
      }
    }, [_vm._v("Cumplido?")]), _vm._v(" "), (obj.cumplido) ? _c('md-input-container', [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "disabled": _vm.currentUser.email !== _vm.acuerdo.editorObject.email || _vm.acuerdo.finalizado !== undefined,
        "type": "date"
      },
      model: {
        value: (obj.fecha),
        callback: function($$v) {
          obj.fecha = $$v
        },
        expression: "obj.fecha"
      }
    })], 1) : _vm._e()], 1)], 1)
  })), _vm._v(" "), (_vm.acuerdo.editorObject && _vm.acuerdo.editorObject.email === _vm.currentUser.email && !_vm.acuerdo.finalizado) ? _c('div', {
    staticClass: "container-buttons"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.finalizar()
      }
    }
  }, [_vm._v("Finalizar")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "confirmFeedLider",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("Pedir feedback a lider")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("Seleccione el lider")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "required": "",
      "name": "lideres",
      "id": "lideres"
    },
    model: {
      value: (_vm.miLider),
      callback: function($$v) {
        _vm.miLider = $$v
      },
      expression: "miLider"
    }
  }, _vm._l((_vm.lideres), function(lider) {
    return _c('md-option', {
      key: lider['.key'],
      attrs: {
        "value": lider.email
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": lider.photoURL,
        "alt": "Avatar"
      }
    })]), _vm._v(" \n            " + _vm._s(lider.displayName) + "\n          ")], 1)
  }))], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("Seleccione un lider antes de confirmar")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onConfirmFeedLider('cancel', 'confirmFeedLider')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onConfirmFeedLider('ok', 'confirmFeedLider')
      }
    }
  }, [_vm._v("Confirmar")])], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "toastLider",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 4000
    },
    on: {
      "close": function($event) {
        _vm.clearInput()
      }
    }
  }, [_c('span', [_vm._v("El feedback se pidio correctamente a: " + _vm._s(_vm.miLider))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.preguntas) ? _c('div', [_c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right feedback-detail",
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Feedback de " + _vm._s(_vm.feedback.owner) + " por " + _vm._s(_vm.feedback.editor))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close-feedback",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _vm._v(" "), _c('md-list', {
    staticClass: "form-question"
  }, _vm._l((_vm.preguntas), function(preg) {
    return _c('md-list-item', {
      key: preg.key
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('p', {
      staticClass: "md-center question"
    }, [_vm._v(_vm._s(preg.question))]), _vm._v(" "), _c('md-input-container', {
      attrs: {
        "md-inline": ""
      }
    }, [_c('md-textarea', {
      staticClass: "answer",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (preg.answer),
        callback: function($$v) {
          preg.answer = (typeof $$v === 'string' ? $$v.trim() : $$v)
        },
        expression: "preg.answer"
      }
    })], 1)], 1)])
  })), _vm._v(" "), _c('div', {
    staticClass: "container-buttons"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav($event)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), (_vm.feedback.completed) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.editable()
      }
    }
  }, [_vm._v("Volver a editar")]) : _vm._e(), _vm._v(" "), (!_vm.feedback.completed) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.openConfirm('delete-feedback')
      }
    }
  }, [_vm._v("Eliminar")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "delete-feedback",
    attrs: {
      "md-title": '',
      "md-content-html": 'Se va a eliminar el Feedback, esta operacion no puede ser revertida, desea continuar?',
      "md-ok-text": 'Eliminar',
      "md-cancel-text": 'cancelar'
    },
    on: {
      "close": _vm.eliminar
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "input",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event)
      }
    }
  }), _vm._v(" "), _c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('md-menu', {
    ref: "menu",
    staticClass: "md-autocomplete-menu",
    attrs: {
      "md-size": "5",
      "md-direction": "top right"
    }
  }, [_c('span', {
    attrs: {
      "md-menu-trigger": ""
    }
  }), _vm._v(" "), _c('md-menu-content', {
    staticClass: "content-autocomplete"
  }, _vm._l((_vm.arrayFilter), function(item) {
    return _c('md-menu-item', {
      key: item['.key'],
      nativeOn: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": item.photoURL
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.displayName))])], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser !== null) ? _c('div', {
    staticClass: "mis-feedbacks"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Proceso de Feedback"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "contenidoPagina",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Esperando Respuesta ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedPendientes.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes feedbacks esperando respuesta aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedPendientes), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.editor,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Recibidos ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedFinalizados.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes Feedbacks finalizados aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedFinalizados), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.editor,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)])], 1), _vm._v(" "), _c('md-speed-dial', {
    staticClass: "md-fab-bottom-right",
    attrs: {
      "md-mode": "scale",
      "md-open": "hover"
    }
  }, [_c('md-button', {
    staticClass: "md-fab md-primary",
    attrs: {
      "md-fab-trigger": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "md-icon-morph": ""
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-clean",
    nativeOn: {
      "click": function($event) {
        _vm.confirmAutoeval('autoeval')
      }
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Reflexión personal")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-clean",
    nativeOn: {
      "click": function($event) {
        _vm.openSelectFluxer('selectFluxer')
      }
    }
  }, [_c('md-icon', [_vm._v("swap_horiz")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Pedir feedback a un compañero")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-primary md-clean",
    nativeOn: {
      "click": function($event) {
        _vm.openFeedLider('confirmFeedLider')
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_downward")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Pedir feedback a mi lider")])], 1)], 1), _vm._v(" "), _c('feedback-lider', {
    ref: "confirmFeedLider",
    attrs: {
      "currentFluxer": _vm.currentFluxer[0]
    }
  }), _vm._v(" "), _c('feedback-companion', {
    ref: "selectFluxer",
    attrs: {
      "isEspontaneo": false,
      "currentFluxer": _vm.currentFluxer[0]
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "autoeval",
    attrs: {
      "md-title": 'Crear una reflexion personal',
      "md-content-html": 'Se creará un feedback para escribir tu reflexión personal',
      "md-ok-text": 'Aceptar',
      "md-cancel-text": 'Cancelar'
    },
    on: {
      "close": _vm.onConfirmAutoeval
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "toastAutoeval",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 4000
    }
  }, [_c('span', [_vm._v("El feedback para realizar la reflexión personal se creó correctamente")])]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "advertencia",
    attrs: {
      "md-title": '',
      "md-content": 'No se puede ver el detalle de un feedback hasta que no sea enviado por quien lo esta escribiendo',
      "md-ok-text": 'Aceptar'
    }
  }), _vm._v(" "), _c('router-view')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser) ? _c('div', {
    staticClass: "Meritos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Mis Meritos"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "contenidoPagina"
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[238]);


// WEBPACK FOOTER //
// static/js/app.3d4fab86d467538c3fd8.js